'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('crypto');

var createCipheriv = _require.createCipheriv;

var createKeccakHash = require('keccak');

var _require2 = require('../util');

var xor = _require2.xor;

var MAC =
/*#__PURE__*/
function () {
  function MAC(secret) {
    _classCallCheck(this, MAC);

    this._hash = createKeccakHash('keccak256');
    this._secret = secret;
  }

  _createClass(MAC, [{
    key: "update",
    value: function update(data) {
      this._hash.update(data);
    }
  }, {
    key: "updateHeader",
    value: function updateHeader(data) {
      var aes = createCipheriv('aes-256-ecb', this._secret, '');
      var encrypted = aes.update(this.digest());

      this._hash.update(xor(encrypted, data));
    }
  }, {
    key: "updateBody",
    value: function updateBody(data) {
      this._hash.update(data);

      var prev = this.digest();
      var aes = createCipheriv('aes-256-ecb', this._secret, '');
      var encrypted = aes.update(prev);

      this._hash.update(xor(encrypted, prev));
    }
  }, {
    key: "digest",
    value: function digest() {
      return this._hash._clone().digest().slice(0, 16);
    }
  }]);

  return MAC;
}();

module.exports = MAC;